import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DatePipe, NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { SubmissionStatus } from 'src/app/models/SubmissionStatus';

@Component({
  selector: 'app-submission-status',
  templateUrl: './submission-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, NgClass, TranslatePipe],
})
export class SubmissionStatusComponent {
  @Input({ required: true }) submissionStatus!: SubmissionStatus;
  /** While the payer is being re-inquired, items show a spinner instead of their status. */
  @Input() checking = false;

  readonly dateFormat = 'MMM d, y h:mm a';

  /** Final outcomes get their own icon and color; anything else is informational. */
  static readonly outcomeStyles = new Map<string | undefined, OutcomeStyle>([
    [
      'SubmissionStatus.Outcome.Completed',
      { icon: 'fa-solid fa-square-check', tone: 'submission-status-completed' },
    ],
    [
      'SubmissionStatus.Outcome.Rejected',
      {
        icon: 'fa-solid fa-circle-exclamation',
        tone: 'submission-status-rejected',
      },
    ],
  ]);

  static readonly defaultOutcomeStyle: OutcomeStyle = {
    icon: 'fa-solid fa-circle-info',
    tone: 'submission-status-info',
  };

  get outcomeStyle(): OutcomeStyle {
    return (
      SubmissionStatusComponent.outcomeStyles.get(
        this.submissionStatus.outcomeKey,
      ) ?? SubmissionStatusComponent.defaultOutcomeStyle
    );
  }
}

interface OutcomeStyle {
  icon: string;
  tone: string;
}
